export default __webpack_public_path__ + "static/media/snlc_header.ce6aaeae.svg";